import { useOutletContext } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

import { useHeatData } from "api/heat";
import { useGasData } from "api/gas";

import ThermalEnergy from "components/ThermalEnergy";
import ThermalEnergyConsumed from "components/ThermalEnergyConsumed";
import ThermalEfficiency from "components/ThermalEfficiency";
import ThermalCost from "components/ThermalCost";
import ExchangeRateOutput from "components/ExchangeRateOutput";

export default function ThermalData() {
  const { user } = useAuth0();

  const [farmName, dayRange] = useOutletContext<any>();

  const { data: heatData } = useHeatData(user["https://hasura.io/jwt/claims"]["x-hasura-user-id"], dayRange, farmName);
  const { data: gasData } = useGasData(user["https://hasura.io/jwt/claims"]["x-hasura-user-id"], dayRange, farmName);

  return !gasData ? null : (
    <>
      <div className="mt-5 px-5 lg:px-12 max-w-sm md:max-w-7xl mx-auto grid gap-5 md:grid-cols-2 lg:grid-cols-3 items-start">
        <div className="col-span-2 output-card p-7">
          <div className="flex-shrink-0 mb-3 font-bold">Thermal Energy Output</div>
          <div className="flex flex-col justify-between">
            <ThermalEnergy className="pb-2" data={heatData ? heatData.heat : []} />
            <div className="mt-7 pt-5 border-t border-gray-200 border-dotted -ml-7 -mr-7"></div>
            <ThermalEnergyConsumed className="pb-3" data={heatData ? heatData.heat : []} />
          </div>
        </div>
        <div className="space-y-14">
          <ThermalEfficiency data={heatData ? heatData.total : null} />
          <ThermalCost className="mt-5" gasData={gasData ? gasData.total : null} heatData={heatData ? heatData.total : null} />
        </div>
      </div>
      <ExchangeRateOutput title="Gas Price" unit="m3" rate={gasData?.total.price} timestamp={gasData?.total.timestamp} />
    </>
  );
}
